import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "./Motion";
import { scrollToId } from "../../lib/scroll";
import { IMG } from "../../lib/site";

export const VideoBanner = () => (
  <section data-testid="video-banner" className="relative overflow-hidden bg-[#0B0F17] py-24 lg:py-32">
    <video src="/media/loop.mp4" poster={IMG.desksA} autoPlay muted loop playsInline preload="metadata" aria-hidden="true"
      className="absolute inset-0 h-full w-full scale-110 object-cover opacity-30 blur-2xl" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0B0F17] via-[#0B0F17]/70 to-[#0B0F17]/40" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-7">
        <p className="font-mono-k text-xs uppercase tracking-[0.28em] text-[#E3C45A]">Take a look inside</p>
        <MaskLines className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.02] text-white"
          lines={["Your seat is ready.", <span className="text-gold">Come see it in person.</span>]} />
        <Reveal delay={0.15} className="mt-10 flex flex-wrap gap-3">
          <button onClick={() => scrollToId("contact")} data-testid="video-cta-visit"
            className="btn-gold group inline-flex items-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold">
            Schedule a Visit <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
          </button>
        </Reveal>
      </div>
      <Reveal className="lg:col-span-5">
        <div className="relative mx-auto w-full max-w-[380px] overflow-hidden rounded-[28px] border border-white/15 shadow-[0_40px_120px_-30px_rgba(0,0,0,.9)]">
          <video src="/media/loop.mp4" poster={IMG.desksA} autoPlay muted loop playsInline preload="metadata"
            data-testid="video-banner-player" className="aspect-[9/10] w-full object-cover" />
          <span className="font-mono-k absolute left-4 top-4 flex items-center gap-2 rounded-full bg-black/50 px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] text-white backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" /> Walkthrough
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);
